var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubRibbon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L36.8 36.8H41.6L45.44 45.44L80 80V0H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9604 34.88C36.1604 32 38.0804 28.8 38.0804 28.8C39.0404 26.56 38.7204 25.28 38.7204 25.28C38.4004 23.04 39.6804 24.64 39.6804 24.64C40.9604 26.24 40.3204 28.16 40.3204 28.16C39.3604 31.36 41.9204 32.96 43.2004 33.28",
    fill: "#294075"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7998 36.8C36.7998 36.8 38.0798 37.44 38.3998 36.8L42.8798 32.32C43.8398 31.68 44.7998 31.36 45.4398 31.36C42.8798 27.84 40.6398 23.68 46.0798 18.24C47.6798 16.64 49.2798 16 51.1998 16C51.5198 15.36 52.1598 13.76 55.0398 12.48C55.0398 12.48 56.6398 13.44 57.2798 17.6C58.5598 18.24 59.8398 19.2 61.1198 20.48C62.3998 21.76 63.3598 23.04 63.9998 24.32C68.4798 25.28 69.4398 26.56 69.4398 26.56C68.1598 29.12 66.5598 30.08 65.9198 30.08C65.9198 32 65.2798 33.6 63.6798 35.2C58.5598 40.32 54.0798 38.4 50.5598 35.84C50.5598 36.8 50.2398 38.08 48.9598 39.36L45.1198 42.88C44.7998 43.2 45.4398 44.48 45.4398 44.48L36.7998 36.8Z",
    fill: "#294075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubRibbon);
export default __webpack_public_path__ + "static/media/github-ribbon.fa98cb0c14118fb8fc3a3df541a0c6b6.svg";
export { ForwardRef as ReactComponent };